'use strict';

var _classCallCheck = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var byteUtils = require('./byte-utils.js');

var defaultChunkSize = 256;

var Bl = /*#__PURE__*/function () {
  function Bl() {
    var chunkSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultChunkSize;

    _classCallCheck(this, Bl);

    this.chunkSize = chunkSize;
    this.cursor = 0;
    this.maxCursor = -1;
    this.chunks = [];
    this._initReuseChunk = null;
  }

  _createClass(Bl, [{
    key: "reset",
    value: function reset() {
      this.chunks = [];
      this.cursor = 0;
      this.maxCursor = -1;

      if (this._initReuseChunk !== null) {
        this.chunks.push(this._initReuseChunk);
        this.maxCursor = this._initReuseChunk.length - 1;
      }
    }
  }, {
    key: "push",
    value: function push(bytes) {
      var topChunk = this.chunks[this.chunks.length - 1];
      var newMax = this.cursor + bytes.length;

      if (newMax <= this.maxCursor + 1) {
        var chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
        topChunk.set(bytes, chunkPos);
      } else {
        if (topChunk) {
          var _chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;

          if (_chunkPos < topChunk.length) {
            this.chunks[this.chunks.length - 1] = topChunk.subarray(0, _chunkPos);
            this.maxCursor = this.cursor - 1;
          }
        }

        if (bytes.length < 64 && bytes.length < this.chunkSize) {
          topChunk = byteUtils.alloc(this.chunkSize);
          this.chunks.push(topChunk);
          this.maxCursor += topChunk.length;

          if (this._initReuseChunk === null) {
            this._initReuseChunk = topChunk;
          }

          topChunk.set(bytes, 0);
        } else {
          this.chunks.push(bytes);
          this.maxCursor += bytes.length;
        }
      }

      this.cursor += bytes.length;
    }
  }, {
    key: "toBytes",
    value: function toBytes() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var byts;

      if (this.chunks.length === 1) {
        var chunk = this.chunks[0];

        if (reset && this.cursor > chunk.length / 2) {
          byts = this.cursor === chunk.length ? chunk : chunk.subarray(0, this.cursor);
          this._initReuseChunk = null;
          this.chunks = [];
        } else {
          byts = byteUtils.slice(chunk, 0, this.cursor);
        }
      } else {
        byts = byteUtils.concat(this.chunks, this.cursor);
      }

      if (reset) {
        this.reset();
      }

      return byts;
    }
  }]);

  return Bl;
}();

exports.Bl = Bl;